// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4295":"ae88717914ea2bce","4683":"1cfd7d93b014aa71","7042":"f557a09f4e47a5b8","8122":"f169671fa0189316"}[chunkId] + ".js";
};